import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IDetalhePublicoTitulosReceber } from "../../../../../types/api/cadastros/detalhar-publico";
import moment from "moment";
import { formatarDecimalNumber, formatarValorMonetario } from "../../../../../helpers/masks";
import PaperDraggable from "../../../../../components/PaperDraggable";

export default function DialogDetalhe({
    open,
    data,
    handleClose
}: DialogDetalheProps) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Detalhes títulos a receber</DialogTitle>
            <DialogContent>
                {
                    data.titulos &&
                    <TableContainer sx={{ maxHeight: 400 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    {headers.map((item, index) => {
                                        return (
                                            <TableCell key={index} align={item.numeric ? 'right' : 'left'}>
                                                <Typography fontWeight={'bold'} variant='subtitle2'>{item.label}</Typography>
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data.titulos.map((row, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={{ paddingX: 2 }}>
                                                    {moment(row.data_vencimento).format('DD/MM/YYYY')}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 2 }} >
                                                    {row.dias_atraso}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 2 }} align="right">
                                                    {formatarValorMonetario(row.saldo_principal)}
                                                </TableCell>
                                                <TableCell sx={{ paddingX: 2 }} align="right">
                                                    {formatarValorMonetario(row.saldo_atualizado)}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                                    <TableCell><b>Total:</b></TableCell>
                                    <TableCell>
                                        <b>{formatarDecimalNumber((data.titulos.reduce((acc, curr) => acc + curr.dias_atraso, 0))/ data.titulos.length)} dias</b>
                                    </TableCell>
                                    <TableCell align="right">
                                        <b>{formatarValorMonetario(data.titulos.reduce((acc, curr) => acc + curr.saldo_principal, 0))}</b>
                                    </TableCell>
                                    <TableCell align="right">
                                        <b>{formatarValorMonetario(data.titulos.reduce((acc, curr) => acc + curr.saldo_atualizado, 0))}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogDetalheProps {
    open: boolean;
    data: IDetalhePublicoTitulosReceber;
    handleClose: VoidFunction;
}

const headers = [
    { label: "Data vencimento" },
    { label: "Dias em atraso" },
    { label: "Saldo", numeric: true },
    { label: "Saldo atualizado", numeric: true }
]